import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../components/LanguageContext';
import './components.css';

const TextLine = () => {
  const { language, translations } = useLanguage();
  const containerRef = useRef(null);

  const textLine = translations['textLineTranslations.json']?.textLine || {};

  const items = [
    { number: '01', title: textLine.items?.find_your_tender?.title?.[language], text: textLine.items?.find_your_tender?.text?.[language], animate: false },
    { number: '02', title: textLine.items?.prepare_your_bid?.title?.[language], text: textLine.items?.prepare_your_bid?.text?.[language], animate: true },
    { number: '03', title: textLine.items?.contract_award_support?.title?.[language], text: textLine.items?.contract_award_support?.text?.[language], animate: true },
    { number: '04', title: textLine.items?.post_contract_support?.title?.[language], text: textLine.items?.post_contract_support?.text?.[language], animate: true },
    { number: '05', title: textLine.items?.appeals?.title?.[language], text: textLine.items?.appeals?.text?.[language], animate: true },
    { number: '06', title: textLine.items?.training?.title?.[language], text: textLine.items?.training?.text?.[language], animate: true },
    { number: '07', title: textLine.items?.tender_alert?.title?.[language], text: textLine.items?.tender_alert?.text?.[language], animate: true },
  ];

  const renderTextWithStyles = (text) => {
    if (!text) return null;
    const keywords = ['Education', 'Experience', 'Languages', 'Location'];
    return text.split('\n').map((line, index, array) => {
      const parts = line.split(new RegExp(`(${keywords.join('|')})`, 'g')).map((part, i) => {
        if (keywords.includes(part)) {
          return <span key={i} style={{ fontWeight: 700 }}>{part}</span>;
        }
        return part;
      });
      return (
        <React.Fragment key={index}>
          {parts}
          {index < array.length - 1 && <br />}
        </React.Fragment>
      );
    });
  };

  return (
    <div className="text_line-container" ref={containerRef}>
      <div className="top_text">
        <p className="top_descr">{renderTextWithStyles(textLine.top_description?.[language])}</p>
        <div className="text_col-line">
          {items.map((item, index) => (
            <AnimatedItem key={index} item={item} renderTextWithStyles={renderTextWithStyles} />
          ))}
        </div>
      </div>
    </div>
  );
};

const AnimatedItem = ({ item, renderTextWithStyles }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { threshold: 0.3, once: true });

  return (
    <motion.div
      ref={ref}
      className="text_number-item"
      initial={item.animate ? { opacity: 0.5 } : {}}
      animate={item.animate && isInView ? { opacity: 1 } : item.animate ? { opacity: 0.5 } : {}}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      <p className="text_number">{item.number}</p>
      <div className="descr_number">
        <p className="descr_title">{item.title}</p>
        <p className="descr_text">{renderTextWithStyles(item.text)}</p>
      </div>
    </motion.div>
  );
};

export default TextLine;